export default {
  pickup: 'Recogida',
  delivery: 'Entrega',
  ongoing_order: 'Pedido en curso',
  view_more: 'Toca para ver los detalles',
  status: {
    rejected: {
      title: 'Pedido rechazado',
      description: 'Toca para ver los detalles',
    },
    created: {
      description: 'Pedido recibido',
    },
    reviewed: {
      description: 'Tu pedido ha sido visto',
    },
  },
  order_type: {
    pickup: 'recogida',
    delivery: 'entrega',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Tu pedido ha sido visto',
    order_confirmed: '#{{number}} Confirmado para las {{time}}',
    order_preparation_up_time_changed: '#{{number}} Hora de {{type}} cambiada a {{time}}',
    order_preparing: 'Tu pedido #{{number}} está siendo preparado',
    order_rejected: 'Pedido #{{number}} rechazado',
  },
  error_messages: {
    failed_to_load: 'Algo salió mal, por favor inténtalo de nuevo.',
  },
};
